<script setup lang="ts">
import {computed, ref} from 'vue';
import {ElInput, ElOption, ElSelect, ElTable, ElTableColumn} from 'element-plus';
import {DashboardReeksEnum, DashboardReeksEnum_name, ReeksNotitie} from 'common';

const props = defineProps<{
    notities: ReeksNotitie[];
    reeksen: DashboardReeksEnum[];
}>();

const reeksFilter = ref<DashboardReeksEnum[]>([]);
const zoek        = ref<string>('');

const getoond = computed<ReeksNotitie[]>(() => {
    const z: string = zoek.value.trim().toLowerCase();
    return props.notities.filter(n =>
        (reeksFilter.value.length === 0 || reeksFilter.value.includes(n.reeks))
        && (z === '' || n.toelichting.toLowerCase().includes(z) || n.organisatie.toLowerCase().includes(z)),
    );
});
</script>

<template>
    <div class="flex flex-col gap-2">
        <div class="flex flex-row flex-wrap items-center gap-4">
            <span class="font-semibold text-zzc-blue">Toelichtingen</span>
            <el-select v-model="reeksFilter" multiple collapse-tags placeholder="Reeks" class="w-72">
                <el-option v-for="r in reeksen" :key="r" :value="r" :label="DashboardReeksEnum_name(r)"/>
            </el-select>
            <el-input v-model="zoek" placeholder="Zoeken" clearable class="w-64"/>
        </div>
        <el-table :data="getoond" stripe size="small" max-height="400">
            <el-table-column prop="organisatie" label="Organisatie" width="160"/>
            <el-table-column label="Reeks" width="260">
                <template #default="scope">{{ DashboardReeksEnum_name(scope.row.reeks) }}</template>
            </el-table-column>
            <el-table-column prop="kwartaal" label="Kwartaal" width="100"/>
            <el-table-column prop="toelichting" label="Toelichting" min-width="300" show-overflow-tooltip/>
        </el-table>
    </div>
</template>
